import { clamp } from "lodash-es";
import {
	EARLY_FREEDOM_SAVING_FALLBACK,
	EARLY_FREEDOM_SAVING_MAX,
	EARLY_FREEDOM_SAVING_MIN,
} from "web_myplann/Inspiration/EarlyFreedom/constants";
import { useInspirationBaseline } from "web_myplann/Inspiration/Hooks/useInspirationBaseline";

export type ResolvedEarlyFreedomBaseline = {
	age?: number;
	monthlySaving: number;
};

export const useEarlyFreedomBaseline = (): ResolvedEarlyFreedomBaseline => {
	const { age, freeCashflow } = useInspirationBaseline();

	return {
		age,
		monthlySaving:
			freeCashflow > 0
				? clamp(
						freeCashflow,
						EARLY_FREEDOM_SAVING_MIN,
						EARLY_FREEDOM_SAVING_MAX,
					)
				: EARLY_FREEDOM_SAVING_FALLBACK,
	};
};
